// @core/api/endpoints/localization/get_missing_translations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTranslationKeysResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Get missing translations
 * Returns translation keys that have no translation for the specified locale.
 */
export async function GetMissingTranslations(
  params?: {
    locale_code?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListTranslationKeysResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/keys/missing`;
  const requestOptions = options;
  return client.get<ListTranslationKeysResponse>(requestPath, { ...requestOptions, params });
}
